export default "__VITE_ASSET__BwBuGsGl__"